import React from "react";
import DefaultLayout from "app/layouts/DefaultLayout";
import MainMenuGrid from "app/components/MainMenuGrid";
import MainMenuItem from "app/components/MainMenuItem";

function HomePage() {
  return (
    <DefaultLayout
      headerProps={{
        headerClassName: "md:!block",
        // pageTitle: "ホーム",
      }}
    >
      <MainMenuGrid>
        <div className="flex items-center justify-center aspect-square w-full h-full p-[10%]">
          <MainMenuItem.MyPage />
        </div>
        <div className="flex items-center justify-center aspect-square w-full h-full p-[10%]">
          <MainMenuItem.Reservation />
        </div>
        <div className="flex items-center justify-center aspect-square w-full h-full p-[10%]">
          <MainMenuItem.Recommended />
        </div>
      </MainMenuGrid>
    </DefaultLayout>
  );
}

export default HomePage;
